import React from "react";
import KickImage from 'Reuseables/KickImage';
import classNames from "classnames";
import propTypes from "prop-types";
import styled from "styled-components";
import jcbIcon from "../../../images/jcb.jpeg";
import masterCard from "../../../images/master-card.png";
import visaIcon from "../../../images/visa.png";
import { FontNunitoBold } from "../../../reusablestyled";
import { getCloudImageUrl } from "../../../utils";
import { TextRupiah } from "../../Text";

const RadioWrapper = styled.div`
  border-bottom: ${(props) => (props.bordered ? "1px solid #ddd" : "none")};
  pointer-events: ${(props) => (!props.active ? "none" : "auto")};
  opacity: ${(props) => (!props.active ? "0.5" : "1")};
  margin-bottom: 1rem;
  padding-bottom: 0.5rem;
`;
// border-bottom: ${(props) => (props.bordered ? "1px solid #ddd" : "none")};
const RadioWrapperForUpdatePayment = styled.div`
  pointer-events: ${(props) => (!props.active ? "none" : "auto")};
  opacity: ${(props) => (!props.active ? "0.5" : "1")};
  margin-bottom: 0;
  padding-bottom: 0;
  display: flex;
  justify-content: start;
  align-items: center;
  width: 100%;
  .payment-methods-logo-update-payment {
    width: ${(props) => (props.isFullWallet ? "40px" : "48px")};
    height: ${(props) => (props.isFullWallet ? "30px" : "16px")};
    margin-right: 10px;
    object-fit: contain;
  }
`;
const RadioLabel = styled.label`
  display: flex;
  position: relative;
  align-items: center;
  cursor: pointer;
  & span.icon {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 20px;
    height: 20px;
    font-size: 1rem;
    padding: 0rem 0.125rem;
    border-radius: 50%;
  }
  & .icon-wrapper {
    display: flex;
    align-items: center;
    position: relative;
    left: -1rem;
    &.flex-start {
      align-items: flex-start;
    }
  }
  & span.icon::before {
    font-family: "FontAwesome";
    content: "\f10c";
  }
  & span.icon::after {
    font-family: "FontAwesome";
    content: "\f111";
    display: none;
  }
  & input:checked ~ .icon-wrapper > span.icon,
  &:hover span.icon {
    border: 1px solid #4a4a4a;
  }
  &:hover span.icon::after {
    display: block;
  }
  &:hover span.icon::before {
    display: none;
  }
  & input:checked ~ .icon-wrapper > span.icon::after {
    display: block;
  }
  & input:checked ~ .icon-wrapper > span.icon::before {
    display: none;
  }
  & input {
    opacity: 0;
  }
  & span.span-text {
    margin-left: 0.5rem;
  }
  & .text-wrapper {
    margin-left: 0.5rem;
    span.span-text {
      margin-left: 0;
    }
  }
`;
const RadioLabelForUpdatePayment = styled.label`
  display: flex;
  position: relative;
  align-items: center;
  cursor: pointer;
  width: 100%;
  justify-content: space-between;
  margin-bottom: 0;
  & span.icon {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 20px;
    height: 20px;
    font-size: 1rem;
    padding: 0rem 0.125rem;
    border-radius: 50%;
    align-self: center;
  }
  & .icon-wrapper {
    display: flex;
    align-items: center;
    width: 100%;
    justify-content: space-between;
    position: relative;
    left: -1rem;
    &.flex-start {
      align-items: flex-start;
    }
  }
  & span.icon::before {
    font-family: "FontAwesome";
    content: "\f10c";
  }
  & span.icon::after {
    font-family: "FontAwesome";
    content: "\f111";
    display: none;
  }
  & input:checked ~ .icon-wrapper > span.icon,
  &:hover span.icon {
    border: 1px solid #4a4a4a;
  }
  &:hover span.icon::after {
    display: block;
  }
  &:hover span.icon::before {
    display: none;
  }
  & input:checked ~ .icon-wrapper > span.icon::after {
    display: block;
  }
  & input:checked ~ .icon-wrapper > span.icon::before {
    display: none;
  }
  & input {
    opacity: 0;
  }
  & span.span-text {
    margin-left: 0.5rem;
    font-family: ${FontNunitoBold};
  }
  & .text-wrapper {
    margin-left: 0.5rem;
    line-height: 1.5;
    p {
      margin-bottom: 0;
    }
    span.span-text {
      margin-left: 0;
      font-family: ${FontNunitoBold};
    }
  }
`;

const Text = styled.p`
  font-size: 0.65rem;
  font-weight: ${(props) => (props.header ? 700 : "normal")};
  margin-bottom: ${(props) => (props.header ? ".5rem" : "0rem")};
  font-style: ${(props) => (props.header ? "normal" : "italic")};
`;

const Radio = (props) => {
  if (props.isBuyingOfferDetail) {
    const totalUserCredit = Number(props.balance) + Number(props.sellerCredit);
    const totalAllUserBalance = Number(props.balance) + Number(props.sellerCredit) + Number(props.kickPoints);
    let isWalletDisable = (props.value === "full_wallet" || Number(totalAllUserBalance) < Number(props.totalAmount)) ? true : false;

    return (
      <RadioWrapperForUpdatePayment
        bordered={props.value === "full_wallet" ? isWalletDisable : props.bordered}
        active={props.active}
        isFullWallet={props.value === "full_wallet" ? true : false}
        className="RADIO WRAPPER radio-wrapper-for-update-payment"
      >
        {props.item.logo && (
          <KickImage
            className="payment-methods-logo-update-payment"
            src={`${getCloudImageUrl(
              props.item.logo,
              200
            )}`}
            alt="payments-logo"
          />
        )}
        <RadioLabelForUpdatePayment active={props.active}>
          <input
            type="radio"
            name={props.name}
            value={props.value}
            checked={props.checked}
            onChange={props.onChange}
          />
          <div
            className={classNames("icon-wrapper", {
              "flex-start": props.title !== null,
            })}
          >
            {props.title && props.value !== "mandiri_credit_card" ? (
              <div className="text-wrapper">
                <span className="span-text">
                  {props.item.label === "Other Virtual Account" ||
                    props.value === "full_wallet" ||
                    props.value === "gopay" ||
                    props.item.label === "Credit Card / Debit Card / Installments"
                    ? ""
                    : props.title}{" "}
                  {props.children}
                </span>
                {props.value === "full_wallet" && (
                  <>
                    <p>
                      Credit Balance:{" "}
                      <TextRupiah
                        prefix="IDR. "
                        color="black"
                        align="right"
                        value={totalUserCredit.toString()}
                      />
                    </p>
                    <p>
                      Kick Points Balance:{" "}
                      <TextRupiah
                        prefix="IDR. "
                        color="black"
                        align="right"
                        value={props.kickPoints.toString()}
                      />
                    </p>
                  </>
                )}
              </div>
            ) : (
              <span className="span-text">{props.children}</span>
            )}
            <span className="icon"></span>
          </div>
        </RadioLabelForUpdatePayment>
      </RadioWrapperForUpdatePayment>
    );
  }

  return (
    <RadioWrapper
      bordered={props.bordered}
      active={props.active}
      className="RADIO WRAPPER"
    >
      <RadioLabel active={props.active}>
        <input
          type="radio"
          name={props.name}
          value={props.value}
          checked={props.checked}
          onChange={props.onChange}
        />
        <div
          className={classNames("icon-wrapper", {
            "flex-start": props.title !== null,
          })}
        >
          <span className="icon"></span>
          {props.title && props.value !== "mandiri_credit_card" ? (
            <div className="text-wrapper">
              <Text header>{props.title}</Text>
              <span className="span-text">{props.children}</span>
            </div>
          ) : (
            <span className="span-text">{props.children}</span>
          )}
        </div>
      </RadioLabel>
      {props.subTitle ? (
        <Text style={{ marginLeft: "1.5rem" }}>{props.subTitle}</Text>
      ) : null}
      {props.renderSubTitle ? props.renderSubTitle() : null}
      {props.label === "Credit Card / Debit Card / Installments" ? (
        <div style={{ marginLeft: "20px", marginTop: "10px" }}>
          <KickImage
            style={{ width: "8%", marginRight: "10px" }}
            src={visaIcon}
            alt="VISA"
          />
          <KickImage
            style={{ width: "8%", marginRight: "10px" }}
            src={masterCard}
            alt="MASTER CARD"
          />
          <KickImage style={{ width: "8%" }} src={jcbIcon} alt="JCB" />
        </div>
      ) : null}
    </RadioWrapper>
  );
};

export default Radio;

Radio.defaultProps = {
  checked: false,
  title: null,
  subTitle: null,
};

Radio.propTypes = {
  name: propTypes.string,
  value: propTypes.string,
  checked: propTypes.bool,
  onChange: propTypes.func,
  children: propTypes.node,
  title: propTypes.string,
  subTitle: propTypes.string,
};